import { apiDoAuthByVideo, apiReadVideoAction } from '@/api';
import { LoadingMask, showToast } from '@/utils/utils';
import { useRef, useEffect, useState } from 'react';
interface Props {
  showPhoto?: boolean;
  showBlob?: boolean;
  shoDownloadVideo?: boolean;
  onCancel?: (e: any) => void;
}
const options = [
  {
    label: '眨眼',
    value: '1',
  },
  {
    label: '张口',
    value: '2',
  },
  {
    label: '摇头',
    value: '3',
  },
  {
    label: '点头',
    value: '4',
  },
];

export default function FaceRecognition({ showPhoto, showBlob, onCancel, shoDownloadVideo }: Props) {
  const urlParams = new URLSearchParams(window.location.search);
  const iccid = urlParams.get('iccid') || '';
  const [recordedBlob, setRecordedBlob] = useState<Blob | null>(null);
  const [faceType, setfaceType] = useState<string>('');

  useEffect(() => {
    getCameraPermission();
  }, []); // eslint-disable-line
  function getfaceType(type: string) {
    const data = options?.filter((item) => type?.includes(item.value))?.map((item) => item.label);
    if (data?.length === 2) {
      return `先${data[0]},再${data[1]}`;
    } else if (data?.length === 1) {
      return `先${data[0]}`;
    } else if (data?.length === 0) {
      return '动作捕获异常';
    } else if (data?.length > 2) {
      return data?.join('、');
    }
  }

  async function getCameraPermission() {
    const res = await apiReadVideoAction({ iccid });
    if (res.data?.data?.code === 0) {
      setfaceType(res.data?.data?.data);
    } else if (res.data?.data?.code === 60002) {
      showToast(res.data?.data?.msg);
      onCancel && onCancel(false);
    } else {
      onCancel && onCancel(false);
      showToast(res.data?.data?.msg);
    }
  }

  // 上传视频到后端
  const uploadVideoToServer = async () => {
    LoadingMask.show('正在验证...');
    // 使用 File 对象进行上传
    const res = await apiDoAuthByVideo(files[0], iccid);
    if (res.data?.data?.code === 0) {
      showToast(res?.data?.data?.msg || '验证成功');
      onCancel && onCancel(true);
    } else if (res.data?.data?.code === 60002) {
      showToast(res.data?.data?.msg);
      onCancel && onCancel(false);
    } else {
      showToast(res.data?.data?.msg);
    }
    LoadingMask.hide();
  };

  const handleImageUpload = (event: any) => {
    let filesList = event.target.files;
    let _files: File[] = [...files];
    if (filesList && filesList[0]) {
      _files.push(filesList[0]);
    }
    if (_files.length > fileLength) {
      _files = _files.slice(0, fileLength);
    }
    setFiles(_files);
    for (let i = 0; i < filesList.length; i++) {
      const file = filesList[i];
      // 创建FileReader实例
      const reader = new FileReader();

      reader.onload = (e: any) => {
        // 使用文件名或索引来保证顺序
        setFileImgs((prevImages) => [...prevImages, { src: e.target.result, key: file.name || i }]);
      };

      reader.readAsDataURL(file);
    }
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };
  function handleRemoveImg(idx: number) {
    let t = [...files];
    t.splice(idx, 1);
    setFiles(t);
    let tt = [...fileImgs];
    tt.splice(idx, 1);
    setFileImgs(tt);
  }
  const [files, setFiles] = useState<File[]>([]);
  const [fileImgs, setFileImgs] = useState<{ src: string; key: string }[]>([]);
  const fileLength = 1;
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <div style={{ textAlign: 'center', overflow: 'auto', paddingTop: '0px', height: 'calc(100vh - 0px)' }}>
      {!recordedBlob && (
        <>
          <div className="text-center mt-10">
            <div className="font-size-18 mb-10">实人认证</div>
            <div className="font-size-14" style={{ color: '#9E9E9E' }}>
              请确保摄像头光线充足，并将人脸移至圆圈中保持不动
            </div>
          </div>
          <div className="text-center mt-20">
            {/* <div className='font-size-18 mb-5'> 开始后根据此处提示做动作</div> */}
            <div className="font-size-18 mb-5">
              {' '}
              录制时按照<span className="text-color-red">{getfaceType(faceType)}</span>指示做动作
            </div>
          </div>
        </>
      )}
      <div style={{ margin: 'auto' }} className="facingPhoto-box-img pt-16">
        <div
          className={`w-220 h-150 pos-r  overflow-hidden ${files.length >= fileLength ? 'd-none' : ''}`}
          style={{ margin: 'auto' }}
        >
          <img className="w-220 h-150 d-flex-r jc-center" src="/pic/certification/reverseSidePhoto.png" alt="" />
          <input
            className="view-opacity-0 pos-a l-0 t-0 bw-100 bh-100 line-height-60"
            type="file"
            ref={inputRef}
            capture="user"
            accept="video/*"
            onChange={handleImageUpload}
          />
        </div>

        {fileImgs.map((item, idx) => {
          return (
            <div key={item.key} className="w-220 h-150 border pos-r mr-10" style={{ margin: 'auto' }}>
              <video className="w-220 h-150" src={item.src} controls />
              <img
                className="pos-a w-16 h-16 t-0 r-0"
                onClick={() => handleRemoveImg(idx)}
                src="/pic/icon_upload_close.png"
                alt=""
              />
            </div>
          );
        })}
        {fileImgs && fileImgs.length > 0 && (
          <div style={{ marginTop: '60px' }}>
            <button
              onClick={() => {
                setRecordedBlob(null);
                getCameraPermission();
                setFiles([]);
                setFileImgs([]);
              }}
              style={{
                backgroundColor: '#f5f5f5',
                color: '#3278FC',
                padding: '10px 20px',
                borderRadius: '20px',
                cursor: 'pointer',
                marginRight: '10px',
                border: '1px solid #3278FC',
              }}
            >
              重新录制
            </button>

            <button
              onClick={uploadVideoToServer}
              style={{
                backgroundColor: '#1777FF',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '20px',
                cursor: 'pointer',
                marginRight: '10px',
              }}
            >
              录制完成
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
